import { useDebounce } from '@uidotdev/usehooks';
import { useState } from 'react';

export function useDebouncedInput(
  delay: number = 350,
  initialValue: string = ''
): [string, (value: string) => void, string] {
  const [inputValue, setInputValue] = useState<string>(initialValue);
  const debouncedValue = useDebounce(inputValue, delay);

  return [inputValue, setInputValue, debouncedValue];
}
